import { useTexts } from '../../../../contexts/TextsContext';
import { useData } from '../../../../contexts/DataContext';
import SectionTitle from '../shared/sectionTitle/SectionTitle';
import VideoGallery from './videoGallery/VideoGallery';
import classes from './videos.module.scss';

const Videos = () => {
    const texts = useTexts();
    const { videos } = useData();

    return (
        <section className={classes.Videos} aria-labelledby="videos-heading">
            <div className={classes.Inner}>
                <div className={classes.Heading}>
                    <SectionTitle id="videos-heading" primaryText={texts.videosHeading} />
                    <p className={classes.Subtitle}>{texts.videosSubHeading}</p>
                </div>
                {videos.length > 0 && <VideoGallery videos={videos} />}
            </div>
        </section>
    );
};

export default Videos;
